import React from "react";
import "./recipe.m.css";
import { Link } from "@quintype/components";

export default function Ingredients({ ingredients }) {
  const items = ingredients.length > 0 && ingredients.split("\n");
  return (
    items.length > 0 && (
      <div styleName="ingredient-wrapper">
        <p styleName="header">Ingredients</p>
        <div styleName="styled-content">
          {items.map((item, index) => (
            <p key={`${item}-${index}`}>{item}</p>
          ))}
        </div>
        <div styleName="styled-links">
          <Link href={`mailto:?subject=Ingredients&body=${items}`} target="_blank">
            <span>Email this grocery list</span>
          </Link>
        </div>
        <div styleName="styled-links">
          <Link href="https://gulfnews.com/cooking-substitution" target="_self">
            Ingredient Substitution Guide
          </Link>
        </div>
      </div>
    )
  );
}
